import { ISmbNode, TSmbExpandedMap } from '../model/types'

import { isSmbNodeExcluded } from './isSmbNodeExcluded'

/**
 * Builds the editor's initial expansion map. Callers may stop at a branch whose children have
 * no Financial Plan; it remains manually expandable, but the initial view does not drill into
 * empty detail. Without a predicate this keeps the original fully-expanded behavior used by
 * status calculations and non-editor helpers.
 */
export const getSmbDefaultExpand = (
  root: ISmbNode,
  shouldExpand: (node: ISmbNode) => boolean = () => true
): TSmbExpandedMap => {
  const expanded: TSmbExpandedMap = {}

  const walk = (node: ISmbNode) => {
    if (!node.children.length || isSmbNodeExcluded(node) || !shouldExpand(node)) {
      return
    }

    expanded[node.id] = true
    node.children.forEach(walk)
  }

  walk(root)

  return expanded
}
